export const ActionTypes = {
  LOADING: "GET_DECISION_LOADING",
  ERROR: "GET_DECISION_ERROR",
  SUCCESS: "GET_DECISION_SUCCESS",
  SET_DECISION: "SET_DECISION",
  DELETE_DECISION: "DELETE_DECISION",
};
